import { useRef, useState } from "react";

import { Container, Row, Col, Form, Button, Image, Card } from "react-bootstrap";


import Header from "../../components/header";
import Footer from "../../components/footer";

export default function AccountSettings() {

  const fileRef = useRef(null);
  const [logo, setLogo] = useState("/logo.webp"); 
  const [form, setForm] = useState({
    phone: "+14798024855",
    about: "Ally.in – WhatsApp Official API Partner",
    address: "",
    description: "Ally Trial Sandbox",
    email: "support@Ally.in",
    industry: "Professional Services",
    website1: "https://Ally.in",
    website2: ""
  });

  const onPickImage = () => fileRef.current?.click();
  const onFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = (ev) => setLogo(ev.target?.result || "");
    reader.readAsDataURL(f);
  };

  const update = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  return (
         <div className="min-vh-100 d-flex flex-column">
    {/* Top Navbar */}
    <Header/>
      <section className="hero">
    <Container fluid className="min-vh-100 p-4">
      <Row>
        {/* Sidebar */}
        <Col xs={12} md={3} lg={2} className="mb-4">
          <Card className="shadow-sm border-0">
            <Card.Body className="p-2">
              <div className="fw-bold text-muted mb-2">Settings</div>

              <div className="d-flex flex-column gap-2">
                <Button variant="light" className="text-start fw-semibold shadow-sm">
                  Account Settings
                </Button>
                <Button variant="light" className="text-start">
                  Billing Information
                </Button>
                <Button variant="light" className="text-start">
                 Reset Password
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>

        {/* Content */}
        <Col xs={12} md={9} lg={10}>
          <Card className="shadow-sm border-0 p-4">
        <Row className="g-4">
          {/* Left: profile picture */}
          <Col xs={12} md={6}>
            <Form.Label className="fw-semibold">Profile picture</Form.Label>
            <div className="d-flex flex-column align-items-start gap-3">
              <Image
                src={logo}
                alt="Company Logo"
                width={120}
                height={120}
                className="object-fit-contain"
              />
              <div>
                <input
                  ref={fileRef}
                  type="file"
                  accept="image/*"
                  onChange={onFile}
                  hidden
                />
                <Button variant="success" onClick={onPickImage}>
                  Change profile picture
                </Button>
              </div>
            </div>
          </Col>

          {/* Right spacer to match screenshot */}
          <Col xs={12} md={6} />

          {/* Two-column form */}
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Phone number</Form.Label>
              <Form.Control
                value={form.phone}
                onChange={update("phone")}
                placeholder="+1 0000000000"
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">About</Form.Label>
              <Form.Control
                value={form.about}
                onChange={update("about")}
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Business address</Form.Label>
              <Form.Control
                value={form.address}
                onChange={update("address")}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Business description</Form.Label>
              <Form.Control
                value={form.description}
                onChange={update("description")}
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Email for business contact</Form.Label>
              <Form.Control
                type="email"
                value={form.email}
                onChange={update("email")}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Business industry</Form.Label>
              <Form.Select value={form.industry} onChange={update("industry")}>
                {[
                  "Professional Services",
                  "E-commerce",
                  "Education",
                  "Healthcare",
                  "Hospitality",
                  "Manufacturing",
                  "Non-profit",
                  "Other"
                ].map((opt) => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>

          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Business website 1</Form.Label>
              <Form.Control
                type="url"
                value={form.website1}
                onChange={update("website1")}
                placeholder="https://example.com"
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold">Business website 2</Form.Label>
              <Form.Control
                type="url"
                value={form.website2}
                onChange={update("website2")}
                placeholder="https://example.com"
              />
            </Form.Group>
          </Col>
   <Col md={6}>
                <Form.Group>
                  <Form.Label>Customer TimeZone</Form.Label>
                  <Form.Select>
                    <option>(GMT+05:30) India Standard Time</option>
                    <option>(GMT+08:00) Singapore / Malaysia</option>
                    <option>(GMT+07:00) Thailand / Vietnam</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Language</Form.Label>
                  <Form.Select>
                    <option>English</option>
                    <option>Hindi</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Support button enabled</Form.Label>
                  <Form.Select>
                    <option>Yes</option>
                    <option>No</option>
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label>Content direction</Form.Label>
                  <Form.Select>
                    <option>Initial</option>
                    <option>RTL (Arabic)</option>
                  </Form.Select>
                </Form.Group>
              </Col>
          <Col xs={12} className="d-flex gap-3">
            <Button variant="outline-secondary">Cancel</Button>
            <Button variant="success">Save changes</Button>
          </Col>
        </Row>
      </Card>
            
        </Col>
      </Row>
    </Container>
     </section>
          {/* Footer Note */}
          <Footer/>
        </div>
  );
}
